// Generated by scripts/update-seeq-icons.js from src/svg/seeq/capsule.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcCapsule = {
  prefix: 'fak',
  iconName: 'capsule' as IconName,
  icon: [
    1024,
    1024,
    [],
    'e904',
    'M348.2 1024h-128c-25.6 0-51.2-20.5-51.2-51.2v-921.6c0-25.6 20.5-51.2 51.2-51.2h128c20.5 0 35.8 15.4 35.8 35.8v35.9c0 20.5-15.4 35.8-35.8 35.8h-76.8v819.2h76.8c20.5 0 35.8 15.4 35.8 35.9v35.8c0 10.2-15.4 25.6-35.8 25.6zM803.8 1024h-128c-20.5 0-35.8-15.4-35.8-35.8v-35.9c0-20.5 15.4-35.8 35.8-35.8h76.8v-819.2h-76.8c-20.5 0-35.8-15.4-35.8-35.9v-35.8c0-20.5 15.4-35.8 35.8-35.8h128c25.6 0 51.2 20.5 51.2 51.2v921.6c0 41-25.6 61.4-51.2 61.4zM609.3 660.5l-71.7-425c0-15.4-10.2-25.6-25.6-30.7-20.5-5.1-41 5.1-41 25.6l-76.8 297-56.3-153.6c-5.1-10.2-15.4-5.1-15.3 5.1v138.2c0 10.2 0 15.4 5.1 25.6l40.9 112.7c5.1 10.2 15.4 20.5 25.6 25.6 20.5 5.1 35.8-5.1 41-25.6l61.4-245.8 66.6 399.4c0 10.2 10.2 20.5 20.5 25.6 5.1 5.1 10.2 5.1 15.3 5.1 15.4 0 25.6-10.2 30.8-25.6l71.6-199.7c0-5.1 5.1-15.4 5.2-20.5v-148.5c0-10.2-15.4-10.2-15.4-5.1l-81.9 220.2z',
  ],
} satisfies IconDefinition;
